import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import swal from 'sweetalert';
import i18next from 'i18next';
import { loginPin, logoutUser } from '../api/authenticationApi';
import { ERROR_MSG, SUCCESS_MSG } from '../constants/actionTypes';
import URL_PATH from '../helpers/url';
// eslint-disable-next-line import/no-named-as-default
import Login from '../components/Login';
import { resetError } from '../actions/resetAction';
import Footer from '../components/Footer';
import { settingDark, settingEn } from '../helpers/translations/cssClassHelper';
import {
  clearLS, getLS, removeLS, setLS,
} from '../helpers/utils';

class LoginPin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mobilePin: '',
      errors: {},
      isLoading: false,
      btnDisabled: true,
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if ((nextProps.pinVerify === SUCCESS_MSG) || nextProps.pinVerify) {
      this.setState({
        errors: null,
        isLoading: false,
      });
      const lang = getLS('defaultLang') ? getLS('defaultLang') : window.navigator.language;
      setLS('defaultLang', lang);
      i18next.changeLanguage(lang);
      // eslint-disable-next-line react/destructuring-assignment
      this.props.history.push(URL_PATH.URLS.TRANSACTIONS);
    }

    if (nextProps.errors) {
      // eslint-disable-next-line react/destructuring-assignment
      if ((nextProps.errors !== this.state.errors) && (nextProps.errors === ERROR_MSG)) {
        this.setState({ isLoading: false });
        swal('Invalid pin');
        // eslint-disable-next-line react/destructuring-assignment
        this.props.resetError();
      }
    }
  }

  handleChange(e) {
    const getValidated = this.validatePin(e.target.value.length);
    if (getValidated) {
      this.setState({ mobilePin: e.target.value, btnDisabled: false });
    } else {
      this.setState({ mobilePin: e.target.value, btnDisabled: true });
    }
  }

  handleSubmit(e) {
    e.preventDefault();
    this.setState({ isLoading: true });
    const msisdn = getLS('msisdn');
    const operator = getLS('operator');
    const data = {
      msisdn,
      // eslint-disable-next-line react/destructuring-assignment
      pin: this.state.mobilePin,
      operator,
    };
    // eslint-disable-next-line react/destructuring-assignment
    this.props.loginPin(data);
  }

  handleCancel(e) {
    e.preventDefault();
    // eslint-disable-next-line react/destructuring-assignment
    this.props.logoutUser(this.props.history);
  }

  // eslint-disable-next-line class-methods-use-this
  validatePin(pinLength) {
    return pinLength > 3;
  }

  // eslint-disable-next-line react/sort-comp
  componentDidMount() {
    settingEn(i18next);
    settingDark(getLS('dark'));
  }

  // Render page goes here
  render() {
    return (
      <>
        <div id="wrapper">
          <Login
            {...this.props}
            // eslint-disable-next-line react/destructuring-assignment
            isLoading={this.state.isLoading}
            // eslint-disable-next-line react/destructuring-assignment
            val={this.state.mobilePin}
            lblInstruction="Please enter your PIN"
            lblBtn="Confirm"
            lblBtnMsg="*You will receive your PIN via SMS"
            handleSubmit={this.handleSubmit}
            handleChange={this.handleChange}
            handleCancel={this.handleCancel}
            className="illustrationSmall"
            placeholder="PIN"
            type="LoginPin"
            lblPinMsg="We have sent an SMS to your phone containing a PIN. Please enter your PIN to continue."
            lblBtnWhileLoading="Confirming"
            // eslint-disable-next-line react/destructuring-assignment
            btnDisabled={this.state.btnDisabled}
          />
        </div>
        <Footer />
      </>

    );
  }
}

const
  mapStateToProps = (state) => ({
    pinVerify: state.auth.pinVerify,
    errors: state.errors,
  });

const
  mapDispatchToProps = (dispatch) => ({
    logoutUser: (history) => dispatch(logoutUser(history)),
    loginPin: (data) => dispatch(loginPin(data)),
    resetError: () => dispatch(resetError()),
  });

export {
  LoginPin,
};
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(LoginPin));
